<template>
  <div>
    <h3>Настройки</h3>

    <div class="mb-3">
      <button type="button" class="btn btn-primary" @click="openModal()">Добавить</button>
    </div>

    <div v-if="settings.length > 0" class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead>
        <tr>
          <th>Код</th>
          <th>Значение</th>
          <th style="width: 180px;">Действия</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="setting in settings" :key="setting.id">
          <td>{{ setting.key }}</td>
          <td>{{ setting.value }}</td>
          <td>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-outline-danger" @click="deleteSetting(setting.id)">Удалить</button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Нативная модалка Bootstrap -->
    <div class="modal fade" id="settingModal" tabindex="-1" ref="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ editingId ? 'Изменить настройку' : 'Добавить настройку' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <label for="settingCode" class="form-label">Код</label>
                <input
                    type="text"
                    class="form-control"
                    id="settingCode"
                    v-model="formData.key"
                    :disabled="!!editingId"
                    required
                />
              </div>
              <div class="mb-3">
                <label for="settingValue" class="form-label">Значение</label>
                <input
                    type="text"
                    class="form-control"
                    id="settingValue"
                    v-model="formData.value"
                    required
                />
              </div>
              <div class="modal-footer px-0 pb-0">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                <button type="submit" class="btn btn-primary">
                  {{ editingId ? 'Сохранить' : 'Добавить' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted, watch, defineProps} from 'vue'
import {Modal} from 'bootstrap'
import {useServiceSettingsStore} from "@/store/service-settings";

const props = defineProps({
  serviceId: {
    type: [Number, String],
    required: true
  }
})

const settingStore = useServiceSettingsStore()
const settings = ref([])

const modal = ref(null)
let modalInstance = null

const editingId = ref(null)
const formData = ref({
  key: '',
  value: ''
})

const loadSettings = async () => {
  try {
    await settingStore.getList(props.serviceId)
    settings.value = settingStore.settings
  } catch (error) {
    console.error('Ошибка загрузки настроек:', error)
  }
}

onMounted(() => {
  if (modal.value) {
    modalInstance = new Modal(modal.value)
  }
  loadSettings()
})

onUnmounted(() => {
  if (modalInstance) {
    modalInstance.dispose()
  }
})

watch(() => props.serviceId, () => {
  loadSettings()
})

const openModal = (setting = null) => {
  if (setting) {
    editingId.value = setting.id
    formData.value = {key: setting.key, value: setting.value}
  } else {
    editingId.value = null
    formData.value = {key: '', value: ''}
  }
  modalInstance?.show()
}

const submitForm = async () => {
  try {
    if (editingId.value) {
      // Если нужно обновление - добавь метод update в store
      await settingStore.update(editingId.value, formData.value)
    } else {
      await settingStore.create({
        serviceId: props.serviceId,
        key: formData.value.key,
        value: formData.value.value
      })
    }

    modalInstance?.hide()
    editingId.value = null
    formData.value = {key: '', value: ''}
    await loadSettings()
  } catch (error) {
    console.error('Ошибка сохранения настройки:', error)
  }
}

const deleteSetting = async (id) => {
  if (confirm('Вы уверены, что хотите удалить эту настройку?')) {
    try {
      await settingStore.delete(id)
      await loadSettings()
    } catch (error) {
      console.error('Ошибка удаления настройки:', error)
    }
  }
}
</script>